import "./styles.scss";
import React, { FC, useContext } from "react";
import EmbeddedPostsFeed from "../../EmbeddedPostsFeed/EmbeddedPostsFeed";
import { UserContext } from "../../UserContext";

interface IProps {
  company: { team: []; name: string; company_id: string };
}

const CompanyUpdatesContent: FC<IProps> = (props: IProps) => {
  const { company } = props;
  // const { paperstreet } = useSelector((state: IState) => state);
  // const { team } = company ? company : [];
  // @ts-ignore
  const [userContext] = useContext(UserContext);

  return (
    <div>
      <EmbeddedPostsFeed
        userId={userContext.user ? userContext.user.user_id : null}
        companyName={company.name}
        companyIds={[company.company_id]}
        portfolioId={undefined}
        userAdminCompanyIds={undefined}
      />
    </div>
  );
};

export default CompanyUpdatesContent;
